import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet";
import AppNavbar from "../../../components/common/AppNavbar";

/* ══ Single AdSense Unit ══ */
const AdUnit = () => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {}
  }, []);
  return (
    <div className="ad-wrapper">
      <div className="ad-label">Advertisement</div>
      <ins
        className="adsbygoogle"
        style={{ display: "inline-block", width: "300px", height: "300px" }}
        data-ad-client="ca-pub-8585027130601823"
        data-ad-slot="7838136769"
      />
    </div>
  );
};

const H1BWageHike = () => {
  return (
    <>
      <Helmet>
        <script
          async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8585027130601823"
          crossOrigin="anonymous"
        />
        <html lang="en" />
        <title>
          US Proposes Massive H-1B Wage Hike: Impact on Indian Professionals &
          Tech Companies – Bharat Abroad
        </title>
        <meta
          name="description"
          content="The US Department of Labor proposes major H-1B wage increases — up to 33% for entry-level workers. Here's what it means for Indian IT firms, international students, and tech companies like Infosys, TCS, Google, and Microsoft."
        />
        <meta
          name="keywords"
          content="H-1B wage hike 2026, H-1B prevailing wage increase, US Department of Labor H-1B proposal, Indian IT companies H-1B, Infosys TCS H-1B impact, H-1B international students, H-1B entry level salary, H-1B minimum wage 2026, PERM labor certification, Indian professionals US visa, H-1B reform 2026, bharatabroad immigration news"
        />
        <meta name="author" content="Bharat Abroad Editorial" />
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
        />
        <meta name="theme-color" content="#0f2027" />
        <link
          rel="canonical"
          href="https://www.bharatabroad.com/articles/us-h1b-wage-hike-indian-professionals-2026"
        />
        <meta name="geo.region" content="IN" />
        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="US Proposes Massive H-1B Wage Hike: Impact on Indian Professionals & Tech Companies – Bharat Abroad"
        />
        <meta
          property="og:description"
          content="DOL proposes H-1B wage increases of up to 33%. Entry-level minimum could hit $97,746. Deep impact on Infosys, TCS, Wipro, international students, and US tech hiring."
        />
        <meta
          property="og:url"
          content="https://www.bharatabroad.com/articles/us-h1b-wage-hike-indian-professionals-2026"
        />
        <meta property="og:site_name" content="Bharat Abroad" />
        <meta property="og:locale" content="en_IN" />
        <meta
          property="og:image"
          content="https://www.bharatabroad.com/images/articles/h1b-wage-hike-2026-og.jpg"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="article:published_time"
          content="2026-05-08T00:00:00+05:30"
        />
        <meta
          property="article:modified_time"
          content="2026-05-08T00:00:00+05:30"
        />
        <meta property="article:section" content="Immigration" />
        <meta property="article:tag" content="H-1B Visa" />
        <meta property="article:tag" content="US Immigration" />
        <meta property="article:tag" content="Indian IT Companies" />
        <meta property="article:tag" content="Prevailing Wage" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@BharatAbroad" />
        <meta
          name="twitter:title"
          content="US Proposes Massive H-1B Wage Hike — Impact on Indian Professionals – Bharat Abroad"
        />
        <meta
          name="twitter:description"
          content="Entry-level H-1B minimum could hit $97,746. DOL proposes up to 33% wage hike. Infosys, TCS, Wipro, and international students face major changes."
        />
        <meta
          name="twitter:image"
          content="https://www.bharatabroad.com/images/articles/h1b-wage-hike-2026-og.jpg"
        />
        <script type="application/ld+json">{`
          {
            "@context":"https://schema.org","@type":"Article",
            "headline":"US Proposes Massive H-1B Wage Hike: What It Means for Indian Professionals and Tech Companies",
            "description":"The US Department of Labor proposes major H-1B wage increases — up to 33% for entry-level workers. Impact on Indian IT firms, international students, and US tech hiring.",
            "image":{"@type":"ImageObject","url":"https://www.bharatabroad.com/images/articles/h1b-wage-hike-2026-og.jpg","width":1200,"height":630},
            "datePublished":"2026-05-08T00:00:00+05:30",
            "dateModified":"2026-05-08T00:00:00+05:30",
            "author":{"@type":"Organization","name":"Bharat Abroad Editorial","url":"https://www.bharatabroad.com/about"},
            "publisher":{"@type":"Organization","name":"Bharat Abroad","url":"https://www.bharatabroad.com","logo":{"@type":"ImageObject","url":"https://www.bharatabroad.com/images/logo/bharatabroad-logo.png","width":200,"height":60}},
            "mainEntityOfPage":{"@type":"WebPage","@id":"https://www.bharatabroad.com/articles/us-h1b-wage-hike-indian-professionals-2026"},
            "articleSection":"Immigration","inLanguage":"en-IN",
            "keywords":"H-1B wage hike, prevailing wage, DOL proposal, Indian IT companies, Infosys, TCS, Wipro, international students, US immigration 2026"
          }
        `}</script>
        <script type="application/ld+json">{`
          {
            "@context":"https://schema.org","@type":"BreadcrumbList",
            "itemListElement":[
              {"@type":"ListItem","position":1,"name":"Home","item":"https://www.bharatabroad.com"},
              {"@type":"ListItem","position":2,"name":"Immigration","item":"https://www.bharatabroad.com/immigration"},
              {"@type":"ListItem","position":3,"name":"H-1B Wage Hike 2026","item":"https://www.bharatabroad.com/articles/us-h1b-wage-hike-indian-professionals-2026"}
            ]
          }
        `}</script>
        <script type="application/ld+json">{`
          {
            "@context":"https://schema.org","@type":"FAQPage",
            "mainEntity":[
              {"@type":"Question","name":"What is the proposed H-1B wage increase?","acceptedAnswer":{"@type":"Answer","text":"The US Department of Labor proposes raising prevailing wages for H-1B workers by 21–33% depending on skill level. Entry-level (Level I) wages could rise by ~33%, with the minimum reaching approximately $97,746 annually."}},
              {"@type":"Question","name":"How does the H-1B wage hike affect Indian IT companies?","acceptedAnswer":{"@type":"Answer","text":"Indian outsourcing firms like Infosys, TCS, and Wipro that hire large numbers of entry-level H-1B workers would face significantly higher labour costs, potentially reducing profit margins and shifting more work offshore to India."}},
              {"@type":"Question","name":"What is a prevailing wage for H-1B?","acceptedAnswer":{"@type":"Answer","text":"A prevailing wage is the minimum salary a company must legally pay a foreign worker for a specific job in a specific location, determined by occupation, skill level, and geographic region."}},
              {"@type":"Question","name":"When is the public comment deadline for the H-1B wage proposal?","acceptedAnswer":{"@type":"Answer","text":"The Department of Labor is accepting public comments until May 26. After reviewing feedback, the government may finalize, modify, delay, or withdraw the proposal."}},
              {"@type":"Question","name":"How will the H-1B wage hike affect Indian students in the US?","acceptedAnswer":{"@type":"Answer","text":"Indian students may face fewer entry-level sponsorship opportunities, higher preference for experienced candidates, and tougher H-1B competition. However, those with skills in AI, machine learning, cybersecurity, and cloud computing may still see strong demand."}}
            ]
          }
        `}</script>
      </Helmet>

      <AppNavbar />

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,800;0,900;1,700&family=Source+Serif+4:ital,wght@0,300;0,400;0,600;1,300;1,400&family=Barlow:wght@400;500;600;700&display=swap');

        .news-page * { box-sizing: border-box; }
        .news-page { background: #f7f5f0; font-family: 'Source Serif 4', serif; color: #1a1a1a; }

        /* ── Hero ── */
        .news-hero {
          background: linear-gradient(135deg, #0f2027, #203a43, #2c5364);
          color: #fff;
          padding: 52px 0 44px;
          border-bottom: 4px solid #c8a84b;
        }
        .news-hero-eyebrow {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: #c8a84b;
          margin-bottom: 14px;
        }
        .news-hero h1 {
          font-family: 'Playfair Display', serif;
          font-size: clamp(24px, 4.5vw, 46px);
          font-weight: 900;
          line-height: 1.12;
          color: #fff;
          margin-bottom: 16px;
          letter-spacing: -0.5px;
          max-width: 820px;
        }
        .news-hero-deck {
          font-family: 'Source Serif 4', serif;
          font-size: clamp(14px, 2vw, 17px);
          font-weight: 300;
          font-style: italic;
          color: rgba(255,255,255,0.7);
          max-width: 740px;
          line-height: 1.65;
        }
        .news-hero-meta {
          display: flex;
          align-items: center;
          gap: 20px;
          margin-top: 24px;
          padding-top: 20px;
          border-top: 1px solid rgba(255,255,255,0.12);
          flex-wrap: wrap;
        }
        .news-hero-meta span {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          color: rgba(255,255,255,0.45);
          letter-spacing: 0.05em;
          text-transform: uppercase;
        }
        .news-hero-meta .sep { color: rgba(255,255,255,0.15); }

        /* ── Category tabs ── */
        .news-tabs {
          background: #fff;
          border-bottom: 1px solid #e0dbd0;
          position: sticky;
          top: 0;
          z-index: 100;
        }
        .news-tabs-inner {
          display: flex;
          overflow-x: auto;
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .news-tabs-inner::-webkit-scrollbar { display: none; }
        .news-tab {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: #666;
          padding: 14px 20px;
          white-space: nowrap;
          border-bottom: 3px solid transparent;
        }
        .news-tab.active { color: #0f2027; border-bottom-color: #c8a84b; }

        /* ── Body layout ── */
        .news-body { padding: 48px 0 72px; }
        .news-grid {
          display: grid;
          grid-template-columns: 1fr 300px;
          gap: 48px;
          align-items: start;
        }

        /* ── Section block ── */
        .news-section { margin-bottom: 44px; }
        .news-section-head {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 18px;
          padding-bottom: 12px;
          border-bottom: 2px solid #1a1a1a;
        }
        .news-section-tag {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: #fff;
          background: #0f2027;
          padding: 4px 11px;
          border-radius: 3px;
        }
        .news-section-tag.blue  { background: #1a3a6b; }
        .news-section-tag.red   { background: #9b1b1b; }
        .news-section-tag.gold  { background: #c8a84b; color: #1a1a1a; }
        .news-section-tag.green { background: #1a5c38; }

        /* ── Article body ── */
        .article-body p {
          font-size: 15.5px;
          line-height: 1.88;
          color: #2a2a2a;
          margin-bottom: 16px;
          font-weight: 300;
        }
        .article-body strong { font-weight: 600; color: #0f2027; }

        /* ── Sub heading ── */
        .news-h3 {
          font-family: 'Playfair Display', serif;
          font-size: 20px;
          font-weight: 700;
          color: #0f2027;
          margin: 28px 0 10px;
          line-height: 1.3;
        }

        /* ── Bullet list (dash style) ── */
        .news-bullets { list-style: none; padding: 0; margin: 10px 0 16px; }
        .news-bullets li {
          display: flex;
          gap: 12px;
          padding: 10px 0;
          border-bottom: 1px solid #e5e0d5;
          font-size: 15px;
          line-height: 1.72;
          color: #2a2a2a;
          font-weight: 300;
        }
        .news-bullets li:last-child { border-bottom: none; }
        .bullet-dash { font-family: 'Barlow', sans-serif; font-weight: 700; color: #c8a84b; font-size: 18px; line-height: 1.4; flex-shrink: 0; }

        /* ── Wage table ── */
        .wage-table-wrap {
          margin: 24px 0;
          border-radius: 4px;
          overflow: hidden;
          border: 1px solid #ddd8cc;
        }
        .wage-table-head {
          background: #0f2027;
          color: #fff;
          padding: 10px 16px;
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.12em;
          text-transform: uppercase;
        }
        .wage-table { width: 100%; border-collapse: collapse; background: #fff; }
        .wage-table th {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: #888;
          padding: 10px 14px;
          background: #f7f5f0;
          border-bottom: 1px solid #e5e0d5;
          text-align: left;
        }
        .wage-table td {
          font-size: 14px;
          color: #2a2a2a;
          padding: 11px 14px;
          border-bottom: 1px solid #e5e0d5;
          font-weight: 300;
          line-height: 1.55;
        }
        .wage-table tr:last-child td { border-bottom: none; }
        .wage-table .pct {
          font-family: 'Playfair Display', serif;
          font-weight: 700;
          color: #9b1b1b;
          font-size: 16px;
        }

        /* ── Highlight / callout box ── */
        .news-highlight {
          background: #0f2027;
          color: #fff;
          border-radius: 4px;
          padding: 22px 24px;
          margin: 24px 0;
        }
        .news-highlight-label {
          font-family: 'Barlow', sans-serif;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.16em;
          text-transform: uppercase;
          color: #c8a84b;
          margin-bottom: 10px;
        }
        .news-highlight p {
          font-family: 'Source Serif 4', serif;
          font-size: 16px;
          font-style: italic;
          color: rgba(255,255,255,0.88);
          line-height: 1.7;
          margin: 0;
          font-weight: 300;
        }

        /* ── Reactions grid ── */
        .reactions-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 14px;
          margin: 16px 0;
        }
        .reaction-card {
          background: #fff;
          border: 1px solid #e0dbd0;
          border-radius: 4px;
          padding: 18px 20px;
        }
        .reaction-label {
          font-family: 'Barlow', sans-serif;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          margin-bottom: 10px;
          padding-bottom: 8px;
          border-bottom: 2px solid;
        }
        .reaction-label.for  { color: #1a5c38; border-color: #1a5c38; }
        .reaction-label.against { color: #9b1b1b; border-color: #9b1b1b; }
        .reaction-card ul { list-style: none; padding: 0; margin: 0; }
        .reaction-card ul li {
          font-size: 13.5px;
          color: #333;
          padding: 6px 0;
          border-bottom: 1px solid #f0ece4;
          line-height: 1.6;
          font-weight: 300;
          display: flex;
          gap: 8px;
        }
        .reaction-card ul li:last-child { border-bottom: none; }

        /* ── Deadline banner ── */
        .deadline-banner {
          background: #fff8e8;
          border: 1px solid #e8d08a;
          border-left: 4px solid #c8a84b;
          border-radius: 0 4px 4px 0;
          padding: 16px 20px;
          margin: 24px 0;
          display: flex;
          align-items: flex-start;
          gap: 14px;
        }
        .deadline-icon { font-size: 22px; flex-shrink: 0; }
        .deadline-title {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: #8a6a00;
          margin-bottom: 4px;
        }
        .deadline-body {
          font-size: 14.5px;
          color: #5a4400;
          line-height: 1.65;
          font-weight: 300;
        }

        /* ── Sidebar ── */
        .news-sidebar { position: sticky; top: 56px; }
        .sidebar-widget { margin-bottom: 30px; }
        .sidebar-widget-head {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: #fff;
          background: #0f2027;
          padding: 6px 12px;
          margin-bottom: 14px;
          display: inline-block;
        }

        /* Key numbers widget */
        .key-numbers { background: #fff; border: 1px solid #e0dbd0; border-radius: 4px; overflow: hidden; }
        .key-num-item {
          padding: 14px 16px;
          border-bottom: 1px solid #e0dbd0;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .key-num-item:last-child { border-bottom: none; }
        .key-num-label {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.06em;
          color: #888;
          line-height: 1.4;
        }
        .key-num-val {
          font-family: 'Playfair Display', serif;
          font-size: 22px;
          font-weight: 700;
          color: #0f2027;
          text-align: right;
        }
        .key-num-sub {
          font-family: 'Barlow', sans-serif;
          font-size: 10px;
          color: #9b1b1b;
          font-weight: 600;
          text-align: right;
        }

        /* Quick facts */
        .quick-facts { list-style: none; padding: 0; margin: 0; }
        .quick-facts li {
          padding: 10px 0;
          border-bottom: 1px solid #e5e0d5;
          font-size: 13.5px;
          line-height: 1.6;
          color: #333;
          font-weight: 300;
          display: flex;
          gap: 8px;
          align-items: flex-start;
        }
        .quick-facts li:last-child { border-bottom: none; }
        .qf-bullet { width: 6px; height: 6px; border-radius: 50%; background: #c8a84b; flex-shrink: 0; margin-top: 6px; }

        /* Who is affected */
        .affected-list { list-style: none; padding: 0; margin: 0; }
        .affected-item {
          display: flex;
          gap: 10px;
          align-items: flex-start;
          padding: 10px 0;
          border-bottom: 1px solid #e5e0d5;
          font-size: 13px;
          color: #333;
          font-weight: 300;
          line-height: 1.55;
        }
        .affected-item:last-child { border-bottom: none; }
        .affected-icon { font-size: 16px; flex-shrink: 0; }

        /* Ad wrapper */
        .ad-wrapper { background: #fff; border: 1px solid #e0dbd0; border-radius: 4px; padding: 16px; text-align: center; }
        .ad-label { font-family: 'Barlow', sans-serif; font-size: 9px; letter-spacing: 0.14em; text-transform: uppercase; color: #bbb; margin-bottom: 10px; font-weight: 600; }

        /* ── Responsive ── */
        @media (max-width: 900px) {
          .news-grid { grid-template-columns: 1fr; }
          .news-sidebar { position: static; }
          .reactions-grid { grid-template-columns: 1fr; }
        }
        @media (max-width: 600px) {
          .news-hero { padding: 36px 0 30px; }
          .news-body { padding: 32px 0 56px; }
          .wage-table td, .wage-table th { padding: 8px 10px; font-size: 13px; }
        }
      `}</style>

      <div className="news-page">
        {/* ════════ HERO ════════ */}
        <div className="news-hero">
          <Container>
            <div className="news-hero-eyebrow">
              🛂 Immigration · H-1B · May 2026
            </div>
            <h1>
              US Proposes Massive H-1B Wage Hike: What It Means for Indian
              Professionals and Tech Companies
            </h1>
            <p className="news-hero-deck">
              The US Department of Labor wants to raise prevailing wages for
              H-1B workers by up to 33% — a move that could reshape hiring
              across the technology industry, especially for Indian IT firms and
              international students.
            </p>
            <div className="news-hero-meta">
              <span>🕐 8 min read</span>
              <span className="sep">·</span>
              <span>📅 May 18, 2026</span>
              <span className="sep">·</span>
              <span>✍️ Bharat Abroad Editorial</span>
              <span className="sep">·</span>
              <span>🛂 Immigration</span>
            </div>
          </Container>
        </div>

        {/* ════════ TABS ════════ */}

        {/* ════════ BODY ════════ */}
        <div className="news-body">
          <Container>
            <div className="news-grid">
              {/* ══ MAIN COLUMN ══ */}
              <main>
                {/* ── Intro ── */}
                <div className="news-section">
                  <div className="article-body">
                    <p>
                      The United States government has proposed a significant
                      increase in the minimum wages employers must pay foreign
                      workers hired under the H-1B visa programme. The move is
                      aimed at preventing companies from using cheaper overseas
                      labour to undercut American salaries, but it could
                      dramatically reshape hiring across the technology industry
                      — especially for Indian IT firms and international
                      students.
                    </p>
                    <p>
                      The proposal, introduced by the U.S. Department of Labor
                      (DOL), would raise prevailing wages across several visa
                      categories, including H-1B, H-1B1, E-3, and PERM labour
                      certification programmes.
                    </p>
                  </div>
                </div>

                {/* ── What is H-1B ── */}
                <div className="news-section">
                  <div className="news-section-head">
                    <span className="news-section-tag blue">
                      What Is the H-1B Visa?
                    </span>
                  </div>
                  <div className="article-body">
                    <p>
                      The H-1B visa allows U.S. companies to hire highly skilled
                      foreign professionals in specialized occupations such as:
                    </p>
                  </div>
                  <ul className="news-bullets">
                    {[
                      "Software engineering",
                      "Artificial intelligence",
                      "Data science",
                      "Finance",
                      "Healthcare",
                      "Cybersecurity",
                      "Engineering",
                    ].map((item) => (
                      <li key={item}>
                        <span className="bullet-dash">—</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="article-body">
                    <p>
                      Indian nationals are the largest recipients of H-1B visas
                      each year, with major employers including{" "}
                      <strong>
                        Infosys, Tata Consultancy Services, Wipro,
                      </strong>{" "}
                      and <strong>HCLTech</strong>. Large American technology
                      firms such as <strong>Google, Microsoft, Amazon,</strong>{" "}
                      and <strong>Meta</strong> also rely heavily on the
                      programme.
                    </p>
                  </div>
                </div>

                {/* ── What Changed ── */}
                <div className="news-section">
                  <div className="news-section-head">
                    <span className="news-section-tag red">
                      What Changes Has the U.S. Proposed?
                    </span>
                  </div>
                  <div className="article-body">
                    <p>
                      The Department of Labor wants to sharply raise the
                      "prevailing wage" employers must pay H-1B workers.
                    </p>
                  </div>

                  {/* Wage table */}
                  <div className="wage-table-wrap">
                    <div className="wage-table-head">
                      📊 Proposed Wage Increases by Level
                    </div>
                    <table className="wage-table">
                      <thead>
                        <tr>
                          <th>Wage Level</th>
                          <th>Worker Category</th>
                          <th>Proposed Increase</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[
                          {
                            level: "Level I",
                            cat: "Entry-level / freshers",
                            pct: "~33%",
                          },
                          {
                            level: "Level II",
                            cat: "Qualified workers",
                            pct: "~24%",
                          },
                          {
                            level: "Level III",
                            cat: "Experienced professionals",
                            pct: "~21%",
                          },
                          {
                            level: "Level IV",
                            cat: "Highly experienced experts",
                            pct: "~22%",
                          },
                        ].map((row) => (
                          <tr key={row.level}>
                            <td>
                              <strong>{row.level}</strong>
                            </td>
                            <td>{row.cat}</td>
                            <td>
                              <span className="pct">{row.pct}</span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="news-highlight">
                    <div className="news-highlight-label">💰 Key Figure</div>
                    <p>
                      Under the proposal, the minimum prevailing wage for many
                      entry-level H-1B jobs could rise to approximately{" "}
                      <strong>$97,746 annually</strong>, compared with earlier
                      levels around the low-$70,000 range.
                    </p>
                  </div>

                  <div className="article-body">
                    <p>
                      The exact wage varies depending on job role, city,
                      industry, and cost of living. For example, software
                      engineers in{" "}
                      <strong>San Francisco or New York City</strong> would have
                      significantly higher prevailing wages than workers in
                      smaller U.S. cities.
                    </p>
                  </div>
                </div>

                {/* ── Why ── */}
                <div className="news-section">
                  <div className="news-section-head">
                    <span className="news-section-tag">
                      Why Is the U.S. Government Doing This?
                    </span>
                  </div>
                  <div className="article-body">
                    <p>
                      According to the Department of Labor, the current wage
                      system is outdated and does not adequately protect
                      American workers. Officials argue that the wage framework
                      was designed nearly 20 years ago, some employers classify
                      workers at artificially low wage levels, and foreign
                      workers are sometimes hired below market rates.
                    </p>
                  </div>
                  <ul className="news-bullets">
                    {[
                      "Protect American salaries",
                      "Reduce misuse of H-1B visas",
                      "Ensure employers hire foreign workers only for genuine skill shortages",
                      "Encourage companies to prioritize high-skilled talent",
                    ].map((item) => (
                      <li key={item}>
                        <span className="bullet-dash">—</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* ── Prevailing Wage explainer ── */}
                <div className="news-section">
                  <div className="news-section-head">
                    <span className="news-section-tag blue">
                      What Is a "Prevailing Wage"?
                    </span>
                  </div>
                  <div className="article-body">
                    <p>
                      A prevailing wage is the minimum salary a company must
                      legally pay a foreign worker for a particular job in a
                      particular location. The wage is determined by occupation,
                      skill level, and geographic region. For instance, a
                      software engineer in <strong>Seattle</strong> earns much
                      more than one in <strong>Dallas</strong> because of local
                      salary standards.
                    </p>
                  </div>
                </div>

                {/* ── Indian IT Impact ── */}
                <div className="news-section">
                  <div className="news-section-head">
                    <span className="news-section-tag red">
                      Impact on Indian IT Companies
                    </span>
                  </div>
                  <div className="article-body">
                    <p>
                      The proposal could significantly affect Indian outsourcing
                      firms that depend heavily on H-1B staffing models. Many
                      Indian IT companies hire large numbers of fresh graduates,
                      use entry-level H-1B salary categories, and deploy workers
                      to U.S. client sites.
                    </p>
                    <p
                      className="news-h3"
                      style={{
                        fontFamily: "'Playfair Display', serif",
                        fontSize: "18px",
                        fontWeight: 700,
                        color: "#0f2027",
                        margin: "18px 0 10px",
                      }}
                    >
                      If salary floors rise sharply:
                    </p>
                  </div>
                  <ul className="news-bullets">
                    {[
                      "Labour costs increase substantially",
                      "Entry-level hiring becomes expensive",
                      "Profit margins shrink",
                      "Smaller contracts may become unviable",
                    ].map((item) => (
                      <li key={item}>
                        <span className="bullet-dash">—</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="news-highlight">
                    <div className="news-highlight-label">
                      ⚠️ Industry Warning
                    </div>
                    <p>
                      Some companies may reduce H-1B filings. More work could
                      shift offshore to India. Automation and AI adoption could
                      accelerate.
                    </p>
                  </div>
                </div>

                {/* ── Students Impact ── */}
                <div className="news-section">
                  <div className="news-section-head">
                    <span className="news-section-tag gold">
                      Impact on International Students
                    </span>
                  </div>
                  <div className="article-body">
                    <p>
                      The proposed rule may also affect Indian students studying
                      in the United States. Potential consequences include fewer
                      entry-level sponsorship opportunities, higher preference
                      for experienced candidates, tougher competition for H-1B
                      selection, and greater focus on specialized skills.
                    </p>
                    <p>
                      However, professionals with expertise in the following
                      areas may continue to see strong demand despite higher
                      wage requirements:
                    </p>
                  </div>
                  <ul className="news-bullets">
                    {[
                      "AI",
                      "Machine learning",
                      "Cybersecurity",
                      "Semiconductor engineering",
                      "Cloud computing",
                    ].map((item) => (
                      <li key={item}>
                        <span className="bullet-dash">—</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* ── Reactions ── */}
                <div className="news-section">
                  <div className="news-section-head">
                    <span className="news-section-tag">
                      Mixed Reactions Across the Industry
                    </span>
                  </div>
                  <div className="article-body">
                    <p>
                      The proposal has triggered strong debate in the U.S.
                      technology sector.
                    </p>
                  </div>
                  <div className="reactions-grid">
                    <div className="reaction-card">
                      <div className="reaction-label for">
                        ✅ Supporters Say
                      </div>
                      <ul>
                        {[
                          "American workers deserve fair wages",
                          "H-1B abuse has lowered salaries",
                          "Companies should not use foreign labour simply to cut costs",
                        ].map((item) => (
                          <li key={item}>
                            <span>—</span>
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="reaction-card">
                      <div className="reaction-label against">
                        ❌ Critics Argue
                      </div>
                      <ul>
                        {[
                          "The U.S. already faces tech talent shortages",
                          "Startups cannot afford higher salaries",
                          "Innovation may slow down",
                          "Smaller employers may stop sponsoring visas",
                        ].map((item) => (
                          <li key={item}>
                            <span>—</span>
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="article-body">
                    <p>
                      Several business groups have warned that sudden increases
                      could disrupt hiring and reduce competitiveness.
                    </p>
                  </div>
                </div>

                {/* ── Public Comment ── */}
                <div className="news-section">
                  <div className="news-section-head">
                    <span className="news-section-tag gold">
                      Public Comment Window Open Until May 26
                    </span>
                  </div>
                  <div className="deadline-banner">
                    <div className="deadline-icon">📅</div>
                    <div>
                      <div className="deadline-title">
                        Comment Deadline — May 26, 2026
                      </div>
                      <div className="deadline-body">
                        The proposed rule is not final yet. The Department of
                        Labor is currently accepting public comments until May
                        26. After reviewing feedback, the government may
                        finalize the proposal, modify the wage levels, delay
                        implementation, or withdraw certain provisions. More
                        information is available on the Federal Register
                        website.
                      </div>
                    </div>
                  </div>
                </div>

                {/* ── CEO Dashboard Call ── */}
                <div className="news-section">
                  <div className="news-section-head">
                    <span className="news-section-tag">
                      CEO Calls for H-1B Transparency Dashboard
                    </span>
                  </div>
                  <div className="article-body">
                    <p>
                      Amid the debate, American CEO James Blunt has urged USCIS
                      to create a publicly accessible dashboard showing
                      real-time H-1B data. In a post on X (formerly Twitter), he
                      argued that many people misunderstand H-1B statistics
                      because approvals often include extensions, employer
                      transfers, and renewals rather than entirely new workers
                      entering the United States.
                    </p>
                    <p>He suggested USCIS should publish:</p>
                  </div>
                  <ul className="news-bullets">
                    {[
                      "Total net increase in H-1B workers physically present in the U.S.",
                      "New approvals",
                      "Extensions",
                      "Transfers",
                      "Withdrawals",
                      "Cap vs non-cap approvals",
                    ].map((item) => (
                      <li key={item}>
                        <span className="bullet-dash">—</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="article-body">
                    <p>
                      Blunt said improved transparency could reduce
                      misinformation surrounding the visa system.
                    </p>
                  </div>
                </div>

                {/* ── What Next ── */}
                <div className="news-section">
                  <div className="news-section-head">
                    <span className="news-section-tag green">
                      What Happens Next?
                    </span>
                  </div>
                  <div className="article-body">
                    <p>
                      If implemented, the proposal could become one of the
                      largest wage increases in H-1B history. Possible long-term
                      effects include:
                    </p>
                  </div>
                  <ul className="news-bullets">
                    {[
                      "Higher salaries for foreign workers",
                      "Reduced hiring of fresh graduates",
                      "Greater demand for highly skilled specialists",
                      "Increased costs for outsourcing firms",
                      "More selective visa sponsorship practices",
                    ].map((item) => (
                      <li key={item}>
                        <span className="bullet-dash">—</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="article-body">
                    <p>
                      For Indian professionals, the changes could make U.S.
                      opportunities harder to access at entry level — but
                      potentially more rewarding for experienced workers with
                      advanced technical expertise.
                    </p>
                  </div>
                </div>
              </main>

              {/* ══ SIDEBAR ══ */}
              <aside className="news-sidebar">
                {/* Key numbers */}
                <div className="sidebar-widget">
                  <div className="sidebar-widget-head">Key Numbers</div>
                  <div className="key-numbers">
                    {[
                      {
                        label: "Entry-level wage hike",
                        val: "33%",
                        sub: "Level I proposed",
                      },
                      {
                        label: "New minimum wage",
                        val: "$97,746",
                        sub: "Entry-level annual",
                      },
                      {
                        label: "Previous minimum",
                        val: "$70K+",
                        sub: "Low range",
                      },
                      { label: "Comment deadline", val: "May 26", sub: "2026" },
                    ].map((s) => (
                      <div className="key-num-item" key={s.label}>
                        <div>
                          <div className="key-num-label">{s.label}</div>
                          <div className="key-num-sub">{s.sub}</div>
                        </div>
                        <div className="key-num-val">{s.val}</div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Who is affected */}
                <div className="sidebar-widget">
                  <div className="sidebar-widget-head">Who Is Affected</div>
                  <ul className="affected-list">
                    {[
                      { icon: "🏢", text: "Infosys, TCS, Wipro, HCLTech" },
                      { icon: "💻", text: "Google, Microsoft, Amazon, Meta" },
                      { icon: "🎓", text: "Indian students on OPT/H-1B path" },
                      { icon: "🚀", text: "US startups with visa sponsorship" },
                      { icon: "👨‍💼", text: "Entry-level foreign professionals" },
                    ].map((item) => (
                      <li className="affected-item" key={item.text}>
                        <span className="affected-icon">{item.icon}</span>
                        <span>{item.text}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Quick facts */}
                <div className="sidebar-widget">
                  <div className="sidebar-widget-head">Quick Facts</div>
                  <ul className="quick-facts">
                    {[
                      "H-1B is the most-used US work visa",
                      "Indians receive ~70% of all H-1B approvals",
                      "Current wage framework is ~20 years old",
                      "Proposal covers H-1B, H-1B1, E-3 & PERM",
                      "Rule not yet final — comment period open",
                    ].map((fact) => (
                      <li key={fact}>
                        <span className="qf-bullet" />
                        <span>{fact}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Single Ad Unit */}
                <div className="sidebar-widget">
                  <AdUnit />
                </div>
              </aside>
            </div>
          </Container>
        </div>
      </div>
    </>
  );
};

export default H1BWageHike;
